function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 20.167a9.167 9.167 0 110-18.334 9.167 9.167 0 010 18.334zm0-1.834c.196 0 .39-.007.582-.022-1.032-.885-1.989-1.997-2.824-3.309-1.26.193-2.583.185-3.935-.048A7.328 7.328 0 0011 18.334zm-.347-3.786c.96 1.376 2.066 2.457 3.233 3.197.27-.116.531-.247.783-.393a.93.93 0 01.007-.062c.254-1.808.2-3.442-.13-4.941a11.59 11.59 0 01-3.893 2.2zm3.286-4.134a9.78 9.78 0 01-4.27 2.518c-1.2-2.256-2.039-5.076-2.27-8.32a7.292 7.292 0 011.36-.595 818.04 818.04 0 00.56.48c.28.242.517.452.75.665a19.214 19.214 0 011.602 1.634c.968 1.121 1.733 2.317 2.268 3.618zm1.294-1.583c-.57-1.147-1.3-2.22-2.174-3.232a21.004 21.004 0 00-1.906-1.93 7.316 7.316 0 015.376 2.514 11.302 11.302 0 01-1.296 2.648zm.803 1.993c.466 1.49.684 3.096.622 4.842A7.303 7.303 0 0018.333 11a7.309 7.309 0 00-.597-2.903c-.461 1-1.034 1.913-1.7 2.726zM3.92 12.869c1.325.378 2.627.502 3.867.4-1.03-2.09-1.776-4.558-2.102-7.32A7.308 7.308 0 003.667 11c0 .653.085 1.287.246 1.89l.006-.021z"
});

var SvgLiveStreaming = function SvgLiveStreaming(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22"
  }), _ref);
};

export default SvgLiveStreaming;